import {NewEditForm} from '@pages/pilotage-rh/accounts/components/new-edit-form';

export default function EditAccount() {
  return <NewEditForm action="edit" />;
}
